import AdminBusiness from '@/components/admin/AdminBusiness'
import ListClients from '@/components/admin/clients/ListClients'
import RelationsClient from '@/components/admin/clients/RelationsClient'
import ListSuppliers from '@/components/admin/suppliers/ListSuppliers'
import RelationsSupplier from '@/components/admin/suppliers/RelationsSupplier'
import ListSocialReasons from '@/components/admin/social-reasons/ListSocialReasons'
import CreateBudget from '@/components/admin/budgets/CreateBudget'
import ListBudget from '@/components/admin/budgets/ListBudget'
import ShowBudget from '@/components/admin/budgets/ShowBudget'
import ListCampaing from '@/components/admin/campaign/ListCampaign'

export default {
  path: '/admin/business',
  //beforeEnter: requireAuth,
  name: 'AdminBusiness',
  component: AdminBusiness,
  children: [
    {
      path: 'social-reasons',
      component: ListSocialReasons,
    },
    {
      path: 'suppliers',
      component: ListSuppliers,
    },
    {
      path: 'suppliers/relations/:id',
      component: RelationsSupplier,
    },
    {
      path: 'clients',
      component: ListClients,
    },
    {
      path: 'clients/relations/:id',
      component: RelationsClient,
    },
    {
      path: 'budgets',
      component: ListBudget,
    },
    {
      path: 'budgets/create',
      component: CreateBudget,
    },
    {
      path: 'budgets/show/:id',
      component: ShowBudget,
    },
    {
      path: 'campaigns',
      component: ListCampaing
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/adminbusiness.js